import React from 'react';
import { FileTextIcon, FileImageIcon, VideoIcon, EyeIcon, DownloadIcon } from 'lucide-react';
const getIcon = type => {
  switch (type) {
    case 'pdf':
      return FileTextIcon;
    case 'presentation':
      return FileImageIcon;
    case 'video':
      return VideoIcon;
    default:
      return FileTextIcon;
  }
};
export const DocumentCard = ({
  document,
  onPreview
}) => {
  const Icon = getIcon(document.type);
  return <div className="bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-410">
      <div className="p-6" data-id="element-411">
        <div className="flex items-start space-x-4" data-id="element-412">
          <div className="p-2 bg-blue-50 rounded-lg" data-id="element-413">
            <Icon className="h-8 w-8 text-blue-600" data-id="element-414" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-415">
            <h3 className="text-sm font-medium text-gray-900 truncate" data-id="element-416">
              {document.title}
            </h3>
            <p className="text-sm text-gray-500" data-id="element-417">
              {document.size} • {document.date}
            </p>
          </div>
        </div>
      </div>
      <div className="border-t border-gray-200 px-6 py-3 bg-gray-50 flex justify-between items-center" data-id="element-418">
        <span className="text-xs font-medium text-gray-500 uppercase" data-id="element-419">
          {document.type}
        </span>
        <div className="flex space-x-3" data-id="element-420">
          <button onClick={onPreview} className="p-1 text-gray-600 hover:text-blue-600 transition-colors" data-id="element-421">
            <EyeIcon className="h-5 w-5" data-id="element-422" />
          </button>
          <button onClick={() => window.open(document.url, '_blank')} className="p-1 text-gray-600 hover:text-blue-600 transition-colors" data-id="element-423">
            <DownloadIcon className="h-5 w-5" data-id="element-424" />
          </button>
        </div>
      </div>
    </div>;
};